import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {generateRoutePath} from 'epic-common/src/route';
import Header from './Header';
import classNames from 'classnames';

class ConfirmPage extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        status: PropTypes.object,
        history: PropTypes.object,
        title: PropTypes.string,
        android: PropTypes.bool
    };

    componentDidUpdate(prevProps) {
        if (this.props.status !== prevProps.status) {
            const {
                status, android, history
            } = this.props;
            if (!status || !status.registered) {
                if (android) {
                    history.push(generateRoutePath('/mobile/android/sign-up'));
                } else {
                    history.push(generateRoutePath('/mobile/sign-up'));
                }
            }
        }
    }

    render() {
        const {
            content, title, android, status
        } = this.props;
        const confirmData = content.confirm || [];
        const message = [];
        let activeSection;
        for (let x = 0; x < confirmData.length; x++) {
            const item = confirmData[x];
            message.push(
                <div key={`item-${x}`}>
                    <h2>{item.title}</h2>
                    {item.description ? (
                        <div dangerouslySetInnerHTML={{__html: item.description}} />
                    ) : (null)}
                </div>
            );
        }
        if (status && status.platform && status.platform.includes('apple-')) {
            activeSection = (message[0]); //eslint-disable-line
        } else {
            activeSection = (message[1]); //eslint-disable-line
        }
        if (android) {
            activeSection = (message[0]);
        }
        const confirmClass = classNames('confirm-page', {android});
        return (
            <div className={confirmClass}>
                <div className="container-fluid content-container">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 col-md-9 col-md-offset-3 text-center">
                                <div className="content">
                                    <Header android title={title} />
                                    {activeSection}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="heroes" />
                </div>
            </div>
        );
    }
}

export default withRouter(ConfirmPage);
